import { base } from './de/base';
import { objects } from './de/objects';
import { projectPages } from './de/projects';
import { settings } from './de/settings';

/** German texts of the module, below its ID: `projects.nav.projects`. One file per area. */
export const de = { ...base, objects, projectPages, settings };
